import React, { useState } from "react";
import AsyncApiComponent from "@asyncapi/react-component/browser/index";
import "@asyncapi/react-component/styles/default.min.css";
import ReactCodeMirror from "@uiw/react-codemirror";
import { yaml } from "@codemirror/lang-yaml";
import { Link } from "react-router";
import { Container, Header, Icon, List, Segment } from "semantic-ui-react";

function EventBasedApis() {
  const [showExampleSnippet, setShowExampleSnippet] = useState(true);
  const [showExampleUi, setShowExampleUi] = useState(true);
  const api = `asyncapi: '2.6.0'
info:
  title: User Signup Events
  version: '1.0.0'
servers:
  production:
    url: mqtt://broker.example.com
    protocol: mqtt
channels:
  user/signedup:
    subscribe:
      summary: Receive signup events
      message:
        name: UserSignedUp
        payload:
          type: object
          properties:
            userId:
              type: string
            email:
              type: string
`;
  return (
    <Container fluid>
      <Header as="h2" textAlign="center">
        Event based APIs
      </Header>
      <Header dividing>Introduction</Header>
      The <Link to="/event-based-apis">Event based APIs</Link> page will have
      the comprehensive information about the Async API documentation of all the
      Kafka based microservices. The APIs are categorized based on the modules
      to which the APIs belong. The list of modules can be seen in the left
      sidebar.
      <br />
      <br />
      If you click on the the desired module's name in the sidebar, the list of
      Microservices of the module will be expanded down and then the list of
      routes will be listed down. This is slightly different from the REST APIs
      sidebar. When you finally select the version, the Async API documentation
      of the API will be visualized in the right side of the page.
      <br />
      <Header as="h3">Async APIs</Header>
      An AsyncAPI documentation is a structured specification used to define and
      document asynchronous APIs, particularly those that involve event-driven
      architectures, such as message brokers, WebSockets, MQTT, Kafka, or AMQP.
      AsyncAPI is to asynchronous/event-driven APIs what OpenAPI (Swagger) is to
      RESTful APIs. It allows developers to describe how systems publish and
      subscribe to events in a machine-readable format (usually YAML or JSON).
      <Header as="h4">Core components</Header>
      <List as="ol">
        <List.Item as="li">
          <b>info:</b> Metadata about the API.
        </List.Item>
        <List.Item as="li">
          <b>servers:</b> Details of brokers or endpoints.
        </List.Item>
        <List.Item as="li">
          <b>channels:</b> Topics or queues where messages are sent or received.
        </List.Item>
        <List.Item as="li">
          <b>messages:</b> Descriptions of the payloads being exchanged.
        </List.Item>
        <List.Item as="li">
          <b>components:</b> Reusable objects like message schemas or security
          schemes.
        </List.Item>
      </List>
      <Header dividing>Example</Header>
      <Segment.Group>
        <Segment>
          <Header as="h4" onClick={() => setShowExampleSnippet((s) => !s)}>
            Snippet(yaml){" "}
            <Icon name={`${showExampleSnippet ? "angle up" : "angle down"}`} />
          </Header>
          {showExampleSnippet && (
            <ReactCodeMirror
              editable={false}
              value={api}
              extensions={[yaml()]}
            />
          )}
        </Segment>
        <Segment>
          <Header as="h4" onClick={() => setShowExampleUi((s) => !s)}>
            Async API UI{" "}
            <Icon name={`${showExampleUi ? "angle up" : "angle down"}`} />
          </Header>
          {showExampleUi && <AsyncApiComponent schema={api} />}
        </Segment>
      </Segment.Group>
    </Container>
  );
}

export default EventBasedApis;
